'use client';

import { useTranslation as t } from '../../../hooks/useTranslation';
// import { TokenProps, hasToken } from '../../../utils/servicesUtil';
// import jwt_decode from 'jwt-decode';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { getUser } from '../../../utils/auth';
import { EpStepContent } from '../components';
import { EpFormInput } from '../components/EpFormInput';

export default function NotifierEmailInput({
  translations,
}: {
  translations: string[];
}) {
  const {
    setValue,
    unregister,
    formState: { errors },
  } = useFormContext();
  const pathname = usePathname();

  const user = getUser();
  const isPublicPath = pathname.includes('Public');
  const isLogged = user && !isPublicPath;
  const anonymous = useWatch({ name: 'anonymous' });

  useEffect(() => {
    unregister('notifierEmail');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anonymous, isPublicPath]);

  if (anonymous) return null;
  if (isLogged) setValue('notifierEmail', user?.email);

  return (
    <>
      <EpStepContent.Label label={t(translations, 'E-mail')}>
        <EpFormInput
          inputName="notifierEmail"
          inputId="notifierEmail"
          inputType="text"
          inputPlaceholder={t(translations, 'E-mail')}
          inputRequired={!isPublicPath}
          inputIsDisabled={isLogged}
          translations={translations}
          inputWithError={!!errors[`notifierEmail`]}
          inputIsFullWidth
          inputPattern={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/}
        />
      </EpStepContent.Label>
    </>
  );
}
